import { GROUP_SUMMARY } from '../../formName';

import { PureComponent } from 'react';

import FormErrorMessage from 'components/FormErrorMessage';
import { Toggle } from 'components/Toggle/Toggle';
import get from 'lodash/get';
import PropTypes from 'prop-types';

export default class AbsoluteField extends PureComponent {
  static propTypes = {
    input: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    msg: PropTypes.object,
  };

  render() {
    const {
      input,
      msg,
      meta: { touched, error },
    } = this.props;
    return (
      <div className='ml-6 inline-block'>
        <div className='flex items-center'>
          <Toggle
            id={`${GROUP_SUMMARY}-absolute`}
            name={input.name}
            value={input.checked}
            onChange={input.onChange}
            hideStateMessage
            label={get(msg, ['dialog', 'groupSummary', 'inAbsolute'])}
            labelPosition='right'
          />
        </div>
        {touched && error && (
          <FormErrorMessage>{msg.validation[error]}</FormErrorMessage>
        )}
      </div>
    );
  }
}
